// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function InsightsIndex(props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match = url.path;
  var selected;
  if (match && match.hd === "insights") {
    var match$1 = match.tl;
    if (match$1) {
      switch (match$1.hd) {
        case "correlation" :
            selected = match$1.tl ? "dashboard" : "correlation";
            break;
        case "dashboard" :
            selected = "dashboard";
            break;
        default:
          selected = "dashboard";
      }
    } else {
      selected = "dashboard";
    }
  } else {
    selected = "dashboard";
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                            selected === "dashboard" ? "filter-white" : ""
                                          ),
                                          title: "Insights Dashboard",
                                          src: Image$ReactHooksTemplate.dashboard
                                        }),
                                    className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "dashboard" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/insights/dashboard"
                            }),
                        JsxRuntime.jsx("a", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "m-auto inline-block align-middle max-h-full\n                  max-w-full w-auto h-auto inset-0 absolute " + (
                                            selected === "correlation" ? "filter-white" : ""
                                          ),
                                          title: "Insights Correlation",
                                          src: Image$ReactHooksTemplate.distributions
                                        }),
                                    className: "w-full h-16 relative hover:bg-palatinateblue sidebar " + (
                                      selected === "correlation" ? "bg-palatinateblue border-palatinateblue" : ""
                                    )
                                  }),
                              href: "/insights/correlation"
                            })
                      ],
                      className: "min-h-screen w-16 bg-ghostwhite border-r border-gray-300"
                    }),
                JsxRuntime.jsx("div", {
                      children: props.content,
                      className: "w-screen"
                    })
              ],
              className: "flex"
            });
}

var make = InsightsIndex;

exports.make = make;
/* react/jsx-runtime Not a pure module */
